import React from 'react';
import type ServicedeskCmdbConfigureObjectType from '@atlassian/jira-spa-apps-servicedesk-cmdb-configure-object-type/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskCmdbConfigureObjectType = lazyForPaint<
	typeof ServicedeskCmdbConfigureObjectType
>(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-cmdb-configure-object-type", jiraSpaEntry: "async-servicedesk-cmdb-configure-object-type" */ '@atlassian/jira-spa-apps-servicedesk-cmdb-configure-object-type'
		),
);

const InsightConfigureObjectType = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbConfigureObjectType}
		pageId="spa-apps/servicedesk/insight/cmdb-configure-object-type"
		shouldShowSpinner
	/>
);

export default InsightConfigureObjectType;
